export const NAMESPACE = "http://schemas.sharedo.co.uk/autodoc/v1";
export const VERSION = "v2";